<template>
  <label v-if="label" class="form-label">{{ label }}</label>
  <input class="form-control rounded flatpickr-input" :value="value" @blur="input" ref="input" :class="{'is-invalid': isInvalid, addClass}"
         autocomplete="off" :placeholder="placeholder"/>
</template>
<script>
import daterangepicker from "@settings/daterangepicker";

export default {
  emits: ["input"],
  props: {
    label: {
      required: false,
      type: String,
      default: null
    },
    value: {
      required: false,
      type: String,
      default: moment().format('DD/MM/YYYY')
    },
    addClass: {
      required: false,
      type: String,
      default: ''
    },
    parentEl: {
      required: false,
      type: String
    },
    isInvalid: {
      required: false,
      default: false
    },
    placeholder: {
      required: true,
      type: String,
      default: null
    },
    multiple: {
      required: false,
      type: Boolean,
      default: false
    },
    ranges: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    input(event) {
      this.$emit('input', event.target.value);
    },
    clear() {
      $(this.$refs.input).val('').trigger('change')
    },
    setValue(value) {
      $(this.$refs.input).val(value).trigger('change')
    }
  },
  mounted() {
    const options = {
      ...(!this.multiple && {"singleDatePicker": true}),
      ...(
          this.ranges && this.multiple && {ranges: {
              'Hoje': [moment(), moment()],
              'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
              '&Uacute;ltimos 7 dias': [moment().subtract(6, 'days'), moment()],
              '&Uacute;ltimos 30 dias': [moment().subtract(29, 'days'), moment()],
              'Este m&ecirc;s': [moment().startOf('month'), moment().endOf('month')],
              'M&ecirc;s passado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }}
      ),
      "alwaysShowCalendars": true,
      ...daterangepicker,
      showDropdowns: true,
      ...(this.parentEl && {parentEl: this.parentEl}),
      ...(!this.multiple && {autoApply: true, autoUpdateInput: false}),
      ...(this.multiple && {autoUpdateInput: false})
    };

    const rangePicker = $(this.$refs.input).daterangepicker(options);

    let vm = this;

    rangePicker.on('cancel.daterangepicker', function (ev, picker) {
      $(this).val('');
      vm.$emit('input', null)
    });

    rangePicker.on('apply.daterangepicker', function (ev, picker) {
      if (vm.multiple) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
      } else {
        $(this).val(picker.startDate.format('DD/MM/YYYY'))
      }

      vm.$emit('input', $(this).val())
    });
  }
}
</script>
